import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Auszahlungsinfo',
    payouts: 'Auszahlungen',
  },
  form: {
    invoicing_emails: {
      label: 'Rechnungen senden an email',
      placeholder: 'E-Mail-Adresse eingeben',
    },
    payout_schedule: {
      label: 'Auszahlungsplan',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Angehaltene Auszahlungen',
        [PAYOUT_INTERVAL.DAILY]: 'Tägliche Auszahlungen',
        [PAYOUT_INTERVAL.WEEKLY]: 'Wöchentliche Auszahlungen',
        [PAYOUT_INTERVAL.MONTHLY]: 'Monatliche Auszahlungen',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    amount: 'Betrag',
    cash_amount: 'Bargeldbetrag',
    paypal_standalone_amount: 'PayPal-Betrag',
    period: 'Zeitraum',
    paid_at: 'Bezahlt am',
    provider: 'Zahlungsanbieter',
    status: 'Status',
    actions: 'Aktionen',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Bargeld',
    system: 'System',
  },
  buttons: {
    save: 'Speichern',
    actions: 'Aktionen',
    open_report: 'Bericht öffnen',
    open_tracking_url: 'Auszahlung verfolgen',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'Ausstehend',
    [PAYOUT_STATUSES.processing]: 'Bearbeitung',
    [PAYOUT_STATUSES.paid]: 'Bezahlt',
    [PAYOUT_STATUSES.failed]: 'Fehlgeschlagen',
    undefined: 'Unbekannt',
    null: 'Unbekannt',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    successfully_updated: 'Erfolgreich aktualisiert',
  },
};
